import { makePieActionObjs } from "shared/imports/pieActionGenerators"
import { prependAppName } from "shared/imports/sharedHelperFunctions"

const appName = "@@tracking_dashboards/"
const loadTrackingDashboardObjs = makePieActionObjs("load", "TrackingDashboard")
const createTrackingDashboardObjs = makePieActionObjs("post", "TrackingDashboard")
const patchTrackingDashboardObjs = makePieActionObjs("patch", "TrackingDashboard")
const archiveTrackingDashboardObjs = makePieActionObjs("archive", "TrackingDashboard")
const duplicateTrackingDashboardObjs = makePieActionObjs("duplicate", "TrackingDashboard")


export const loadTrackingDashboardActionDict = prependAppName(appName, loadTrackingDashboardObjs.pieDict)
export const createTrackingDashboardActionDict = prependAppName(appName, createTrackingDashboardObjs.pieDict)
export const patchTrackingDashboardActionDict = prependAppName(appName, patchTrackingDashboardObjs.pieDict)
export const archiveTrackingDashboardActionDict = prependAppName(appName, archiveTrackingDashboardObjs.pieDict)
export const duplicateTrackingDashboardActionDict = prependAppName(appName, duplicateTrackingDashboardObjs.pieDict)

const TrackingDashboardActions = {
    ...prependAppName(
        appName,
        {
            ...loadTrackingDashboardObjs.actionTypes,
            ...createTrackingDashboardObjs.actionTypes,
            ...archiveTrackingDashboardActionDict.actionTypes,
            ...duplicateTrackingDashboardActionDict.actionTypes,
            TRACKING_DASHBOARD_FORM_SUBMIT_SEARCHIFY: "TRACKING_DASHBOARD_FORM_SUBMIT_SEARCHIFY",
            TRACKING_DASHBOARD_FILTER_LISTS: "TRACKING_DASHBOARD_FILTER_LISTS",
            SET_NEW_TRACKING_DASHBOARD_DATA_TYPE: "SET_NEW_TRACKING_DASHBOARD_DATA_TYPE",
        }
    )
}

export default TrackingDashboardActions
